<template>
  <Breadcrumbs title="" main="Pages" />
  <div class="container-fluid">
    <div class="faq-wrap">
      <div class="row">
        <div class="col-xl-12">
          <div class="card bg-primary">
            <div class="card-body">
              <p>&nbsp;</p>
              <div class="media faq-widgets">
                <div class="media-body">
                  <h2>{{this.currentLanguage ==='en'?"About us":"เกี่ยวกับเรา"}}</h2>
                  <p>
                    {{ systemName }}
                  </p>
                  <p>A freelance photographer who sells photographs of celebrities to the media,</p>
                  <p>especially one who pursues celebrities and attempts to obtain candid photograph</p>
                </div>
                <vue-feather type="award"></vue-feather>
              </div>
            </div>
          </div>
        </div>
        <p>&nbsp;</p>
        <div class="col-xl-12">
          <div class="card" style="background-color: #d2f0fa">
            <div class="card-body" >
              <p>&nbsp;</p>
              <div class="media faq-widgets">
                <div class="media-body" >
                  <h2>{{this.currentLanguage ==='en'?"Contact us":"ติดต่อเรา"}}</h2>
                  <p>Facebook: <a :href="fbUrl" target="_blank">{{fbName}}</a><br>
                      Line Official: <a target="_blank" :href="lineOaUrl">{{lineOaAdd}}</a><br>
                      Email: {{email}} </p>
                      <p>&nbsp;</p>
                </div>
                <vue-feather type="mail"></vue-feather>
              </div>
            </div>
          </div>
        </div>

         <p>&nbsp;</p>
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="media faq-widgets">
                <img
                  style="align-items: center; width: 440px"
                  src="../../assets/images/logo/logo.png"
                />
              </div>
            </div>
          </div>
        </div>
         <p>&nbsp;</p>
      </div>
    </div>
  </div>
</template>
<script>

import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'

export default {

  setup() {
    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          property: `og:image`,
          content: computed(() => siteData.image),
        },
        ],
     
    })
  },
  data() {
    return {
      currentLanguage: 'th',
      fbName: process.env.VUE_APP_SYSTEM_FACEBOOK_NAME,
      fbUrl: process.env.VUE_APP_SYSTEM_FACEBOOK_URL,
      lineOaAdd: process.env.VUE_APP_SYSTEM_LINE_OA_ADD,
      lineOaUrl: process.env.VUE_APP_SYSTEM_LINE_OA_URL,
      email: process.env.VUE_APP_SYSTEM_EMAIL,
    };
  },
  async created(){
    this.currentLanguage = localStorage.getItem('currentLanguage');
  },


};
</script>